import * as React from "react"
import {
  Menu,
  MenuList,
  MenuOptionGroup,
  MenuButton,
  MenuItemOption,
  Button,
  Badge,
  useColorMode,
  useOutsideClick,
} from "@chakra-ui/react"

const BigMenuButton: React.FC<any> = (props) => (
  <MenuButton
    {...props}
    background="none"
    borderBottom="2px"
    borderRadius={0}
    borderColor="gray.500"
    _hover={{
      borderColor: props.colorMode === "light" ? "gray.900" : "gray.300",
    }}
    _active={{
      background: "none",
    }}
    _focus={{
      outline: 0,
    }}
  />
)

export const FilterMenu: React.FC<{
  options: ({ value: string; el: JSX.Element } | string)[]
  title?: string
  type?: "radio" | "checkbox"
  closeOnSelect?: boolean
  colorScheme?: string
  disabled?: boolean
  minWidth?: string
  maxHeight?: string
  overflowY?: string
  big?: boolean
  onSelect(value: string | string[]): void
}> = ({
  children,
  options,
  title,
  type,
  closeOnSelect,
  colorScheme,
  disabled,
  minWidth,
  maxHeight,
  overflowY,
  big,
  onSelect,
}) => {
  const { colorMode } = useColorMode()
  const ref = React.useRef() as any
  const [isOpen, setIsOpen] = React.useState(false)
  const StyledMenuButton = big ? BigMenuButton : MenuButton
  useOutsideClick({
    ref: ref,
    handler: () => setIsOpen(false),
  })
  return (
    <div ref={ref} style={{ display: "inline-block" }}>
      <Menu closeOnSelect={closeOnSelect} isOpen={isOpen}>
        <StyledMenuButton
          onClick={() => setIsOpen(!isOpen)}
          fontSize={big ? ["xl", null, "2xl", "3xl"] : ["md", null, "lg", "xl"]}
          disabled={disabled}
          colorMode={colorMode}
          as={
            disabled
              ? ({ children: buttonChildren }: any) => (
                  <Badge
                    fontSize={
                      big
                        ? ["2xl", null, "4xl", "5xl"]
                        : ["lg", null, "xl", "2xl"]
                    }
                    verticalAlign="unset"
                    textTransform="unset"
                    colorScheme={colorScheme}
                  >
                    {buttonChildren}
                  </Badge>
                )
              : Button
          }
        >
          {children}
        </StyledMenuButton>
        <MenuList
          minWidth={minWidth || "150px"}
          maxHeight={maxHeight}
          overflowY={overflowY as any}
        >
          <MenuOptionGroup
            color="gray.500"
            title={title}
            type={type || "radio"}
            onChange={(val) => {
              onSelect(val)
              if (closeOnSelect) {
                setIsOpen(false)
              }
            }}
          >
            {options.map((o) => (
              <MenuItemOption
                fontSize={big ? "xl" : "md"}
                key={typeof o === "string" ? o : o.value}
                value={typeof o === "string" ? o : o.value}
              >
                {typeof o === "string" ? o : o.el}
              </MenuItemOption>
            ))}
          </MenuOptionGroup>
        </MenuList>
      </Menu>
    </div>
  )
}
